<template>
  <div class="micro" v-loadmore="loadMore">
    <div class="micro-content">
      <div class="search-wrap border-bottom">
        <router-link tag="div" to="/micro/search">
          <search-fake placeholder="搜索微课"></search-fake>
        </router-link>
      </div>
      <div class="content">
        <card :data="wkList"></card>
        <loading :more="more" :loaded="loaded"></loading>
      </div>
    </div>
    <tab></tab>
  </div>
</template>
<script type="text/ecmascript-6">
import Tab from '@/components/tab/tab'
import Scroll from '../base/scroll/scroll'
import Card from './micro-card'
import SearchFake from '../base/search/search-fake'
import Loading from '../base/loading/loading2'
import {RES_OK, PAGE_SIZE} from '@/api/config'
import {getWkList} from '@/api/weike.js'
export default {
  data() {
    return {
      page: 1,
      wkList: [],
      loaded: false,
      more: true
    }
  },
  created() {
    this._getWkList(this.page)
  },
  components: {
    Tab,
    Card,
    Scroll,
    SearchFake,
    Loading
  },
  methods: {
    _getWkList(page) {
      getWkList(page, PAGE_SIZE, undefined, this.$route.query.teacher).then((res) => {
        let data = res.data
        if (data && data.code === RES_OK && data.data) {
          if (data.data.length) {
            this.wkList.push(...data.data)
            this.loaded = true
            this.page++
          }
          // 加载完毕
          this.more = data.data.length >= PAGE_SIZE
        }
      })
    },
    loadMore() {
      console.log('微课堂执行了loadMore方法')
      if (this.more && this.loaded) {
        this.loaded = false
        this._getWkList(this.page)
      }
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .micro {
    width: 100%
    // position fixed
    // top: 0
    // bottom: 0
    .micro-content {
      font-size: size(26)
    }
  }
  .content
    padding 0 size(30) size(180)
  .search-wrap
    padding size(30)
    width 100%
    background #ffffff
    z-index 9
</style>



// WEBPACK FOOTER //
// src/components/micro/micro.vue